import { Break } from "../Break";
import styles from "./index.module.scss";

export const PageSectionBreak = () => (
    <Break customClass={styles["page-section-break"]} />
);
